// extracted by mini-css-extract-plugin
module.exports = {"easyStepsWrapper":"_1PBLV","easyStepsHeader":"_3oAuv","easyStepsTab":"_3iTp_","easyStepsTabWrapper":"_3tSev","easyTabImageWrapper":"_3lmU1","easyStepsTabContent":"_2_ZTU"};